const locale = {
  'importModal.title': 'Массовый импорт',
  'importModal.button.upload': 'Загрузить файл',
  'importModal.message.parseError': 'Не удалось обработать файл',
  'importModal.table.updatedFieldName': 'Обновляемый столбец',
  'importModal.table.fileColumnTitle': 'Столбец файла',
  'importModal.table.previewValue': 'Предпросмотр данных',
  'importModal.table.defaultValue': 'Значение по умолчанию',
  'importModal.select.placeholder': 'Пожалуйста, выберите',
  'importModal.input.placeholder': 'Пожалуйста, введите',
  'importModal.button.downloadTemplate': 'Скачать шаблон',
};

export default locale;
